import React from 'react';
import { motion } from 'framer-motion';
import {
  GiftIcon,
  HeartIcon,
  HomeModernIcon,
  SparklesIcon,
} from '@heroicons/react/24/outline';
import firmungBild from '../assets/images/PHOTO-2025-07-27-10-08-11 4.jpg';
import personalisierteGeschenkeBild from '../assets/images/PHOTO-2025-07-27-10-08-11 7.jpg';
import romantischeGeschenkeBild from '../assets/images/PHOTO-2025-07-27-10-08-11 9.jpg';
import dekorationBild from '../assets/images/PHOTO-2025-07-27-10-08-32 2.jpg';

const SERVICES = [
  {
    id: 1,
    Icon: GiftIcon,
    title: 'Personalisierte Geschenke',
    description:
      'Individuelle Geschenke für jeden Anlass – von Geburtstagen über Hochzeiten bis hin zu Jubiläen. Mit persönlichen Gravuren mache ich Ihre Geschenke unvergesslich.',
    image: personalisierteGeschenkeBild,
    accent: 'from-wood-400 to-gold-400',
  },
  {
    id: 2,
    Icon: HeartIcon,
    title: 'Romantische Geschenke',
    description:
      'Besondere Geschenke für Ihre Liebsten – ob zum Valentinstag, Jahrestag oder einfach so. Zeigen Sie Ihre Liebe mit einer individuellen Gravur.',
    image: romantischeGeschenkeBild,
    accent: 'from-rose-400 to-wood-400',
  },
  {
    id: 3,
    Icon: HomeModernIcon,
    title: 'Dekoration & Schilder',
    description:
      'Dekorative Elemente und Schilder für Ihr Zuhause oder Geschäft. Von Türschildern über Wanddekorationen bis hin zu saisonalen Akzenten.',
    image: dekorationBild,
    accent: 'from-gold-300 to-wood-500',
  },
  {
    id: 4,
    Icon: SparklesIcon,
    title: 'Firmung, Kommunion & Konfirmation',
    description:
      'Einzigartige Erinnerungsstücke und Geschenke für besondere kirchliche Anlässe – persönlich und liebevoll gestaltet.',
    image: firmungBild,
    accent: 'from-wood-300 to-gold-500',
  },
];

const Services = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {SERVICES.map((service, index) => (
        <motion.article
          key={service.id}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          className="group relative bg-white dark:bg-wood-800 ring-1 ring-wood-100 dark:ring-wood-700 rounded-2xl overflow-hidden shadow-soft hover:shadow-wood hover:ring-gold-300/60 dark:hover:ring-gold-500/40 transition-all duration-500 hover:-translate-y-2 flex flex-col"
        >
          {service.image && (
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src={service.image}
                alt={service.title}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-wood-900/40 to-transparent opacity-60 group-hover:opacity-30 transition-opacity" />
              <div
                className={`absolute -top-3 -right-3 w-16 h-16 rounded-full bg-gradient-to-br ${service.accent} blur-xl opacity-50 group-hover:opacity-80 transition-opacity`}
                aria-hidden="true"
              />
            </div>
          )}

          <div className="p-6 flex-1 flex flex-col">
            <div className="flex items-center gap-3 mb-3">
              <span
                className={`inline-flex items-center justify-center w-11 h-11 rounded-xl bg-gradient-to-br ${service.accent} text-white shadow-soft`}
              >
                <service.Icon className="w-5 h-5" />
              </span>
              <h3 className="text-lg font-display font-semibold text-wood-900 dark:text-cream-50 leading-tight">
                {service.title}
              </h3>
            </div>
            <p className="text-wood-600 dark:text-cream-100/80 text-sm leading-relaxed flex-1">
              {service.description}
            </p>
            <div className="mt-5 pt-4 border-t border-wood-100 dark:border-wood-700 flex items-center justify-between">
              <span className="text-xs uppercase tracking-wider text-wood-500 dark:text-cream-100/60">
                Preis
              </span>
              <span className="text-sm font-semibold text-wood-800 dark:text-cream-50">
                Auf Anfrage
              </span>
            </div>
          </div>
        </motion.article>
      ))}
    </div>
  );
};

export default Services;
